import script from "./ArgonMultipleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonMultipleSelect.vue?vue&type=script&setup=true&lang=js"

import "./ArgonMultipleSelect.vue?vue&type=style&index=0&id=4ec42f0a&scoped=true&lang=css"
import "./ArgonMultipleSelect.vue?vue&type=style&index=1&id=4ec42f0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec42f0a"]])

export default __exports__